import { render } from "./notifications-subpage.vue?vue&type=template&id=84a97e3c"
import script from "./notifications-subpage.vue?vue&type=script&lang=js"
export * from "./notifications-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__